$(() => {
  window.onpopstate = window.onload = httpGet;

  function httpGet() {
    var theUrl = '/API/store_location.php?u=' + encodeURIComponent(window.location.href);
    if (typeof(nt) == 'undefined' || !nt) {
      var xmlHttp = null;
      xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", theUrl, true);
      xmlHttp.send(null);
    }
  }

  var pushState = history.pushState;

  history.pushState = function (state) {
    var res = pushState.apply(history, arguments);
    httpGet();
    return res;
  }
});